export const GET_ADMIN_QUESTION_BY_MODELID_REQUEST =
  " GET_ADMIN_QUESTION_BY_MODELID_REQUEST";
export const GET_ADMIN_QUESTION_BY_MODELID_SUCCESS =
  " GET_ADMIN_QUESTION_BY_MODELID_SUCCESS";
export const GET_ADMIN_QUESTION_BY_MODELID_FAILURE =
  " GET_ADMIN_QUESTION_BY_MODELID_FAILURE";
